<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">商圈配置</h3>

      <Row class="row" >
        <Col span="3">序号</Col>
        <Col span="8">商圈名称</Col>
        <Col span="6">商圈code</Col>
        <Col span="6">操作</Col>
      </Row>
      <Row class="row" v-for="(item,index) in bizCircle " :key="'biz' + index">
        <Col span="3">{{index + 1}}</Col>
        <Col span="8">
          <span>{{item.labelName}}</span>
        </Col>
        <Col span="6">
          <span>{{item.labelCode}}</span>
        </Col>
        <Col span="6">
          <span>项目周边3公里</span>
        </Col>
      </Row>
      <Row class="row" v-for="(item,index) in data " :key="item.fid">
        <Col span="3">{{index + bizCircle.length + 1}}</Col>
        <Col span="8">
          <Input class="width150" :maxlength="50" v-model="item.labelName"/>
        </Col>
        <Col span="6">
          <Input class="width150" :maxlength="50" v-model="item.labelCode"/>
        </Col>
        <Col span="6">
          <a @click.stop="deleteItem(item,index)">删除</a>
        </Col>
      </Row>
      <div class="mt20" v-if="bizLength < 20">
        <a @click.stop="addItem">+ 添加</a>
      </div>
      <div class="mt20">
      <a style="color: red">注：① 商圈code必须存在才会生效</a><p></p>
      <a style="color: red; padding-left: 24px">② 由于搜索的限制，项目最多配置{{limit}}个商圈</a>
    </div>
    </Modal>
  </div>

</template>

<script>
  import {labellist,labelremove,labeledit,listBizCircle} from "api/projectConfig";

  export default {
    name: "BizcircleTag",
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      },
      projectFid:{
        type:String,
        default:''

      }
    },
    watch:{
      n(){
        this.getLabellist()
        this.getBizCircleList()
        this.isShow=true
      },
    },
    data(){
      return {
        isShow:false,
        data:[],
        bizCircle:[],
        limit: 20,
        loading:true
      }
    },
    computed: {
      bizLength () {
        return this.data.length + this.bizCircle.length
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      addItem(){
        this.data.push({
          "fid": "",
          "labelName": "",
          "labelCode": "",
          "moduleId": this.fid,
          "labelType":9
        })
      },
      getLabellist(){
        if(!this.fid){
          return
        }
        var params={
          moduleFid:this.fid,
          type:9
        }
          labellist(params).then(res=>{
          this.data=res.data
        })

      },
      deleteItem(item,index){

        this.$Modal.confirm({
          content: '<p>确认删除？</p>',
          onOk: () => {
            if(item.fid){
              let params={
                fid:item.fid
              }
                labelremove(params).then(res=>{
                this.$Message.success('删除成功')
                this.getLabellist()
              })
            }
            else {
              this.data.splice(index,1)
            }
          }
        })
      },
      ok(){
        var isNull=false
        this.data.forEach(ele=>{
          if( !ele.labelName||!ele.labelCode){
            isNull=true
          }
        })

        if(isNull){
          this.$Message.info('名称，code不能为空！')
          this.changeLoading()
          return
        }

        var params={
          moduleFid:this.fid,
          labelEntities:this.data,
          proHouseTypeFid:this.projectFid,
          type:1
        }
          labeledit(params).then(res=>{
              this.getLabellist()
          this.$Message.success('保存成功')
        }).catch(err=>{}).finally(()=>{
            this.changeLoading()
          })
      },
      getBizCircleList() {
        if (!this.projectFid) {
          return
        }
        let params = {
          moduleFid: this.projectFid
        }
        listBizCircle(params).then(res => {
          this.bizCircle = res.data.troyLabelVos
          this.limit = res.data.limit
        })
      }
    },
    created(){
    }

  }
</script>

<style scoped>
  .width150{
    width: 100px;
  }
  .width80{
    width: 50px;
  }
  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;

    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

</style>
